export default __webpack_public_path__ + "static/media/logo.2674c3bc.png";